import { Instagram, Facebook, Linkedin } from "lucide-react";
import { LogoFull } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

const SOCIALS = [
  { icon: Instagram, label: "Instagram", testid: "social-instagram", href: "https://www.instagram.com/tyrellpropertyservices" },
  { icon: Facebook, label: "Facebook", testid: "social-facebook", href: "https://www.facebook.com/share/19X6CLtj9W/" },
  { icon: Linkedin, label: "LinkedIn", testid: "social-linkedin", href: "#" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#C5A059]/15 bg-[#03070D]">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <LogoFull className="w-44 border border-[#C5A059]/15" />
          <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-slate-400">
            Premium property services, project management and construction solutions
            across Essex &amp; surrounding areas.
          </p>
          <div className="mt-6 flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">
            <span>Build</span><span className="h-1 w-1 rotate-45 bg-[#C5A059]/60" />
            <span>Renovate</span><span className="h-1 w-1 rotate-45 bg-[#C5A059]/60" />
            <span>Transform</span>
          </div>
        </div>

        <nav aria-label="Footer">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#C5A059]">Navigation</h3>
          <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3">
            {NAV.map((l) => (
              <li key={l.href}>
                <button
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  onClick={() => scrollToId(l.href)}
                  className="text-sm font-light text-slate-400 transition-colors hover:text-white"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#C5A059]">Connect</h3>
          <div className="mt-6 flex gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                {...(s.href === "#"
                  ? { onClick: (e) => e.preventDefault(), title: `${s.label} — link coming soon` }
                  : { target: "_blank", rel: "noopener noreferrer", title: `Tyrell Property Services on ${s.label}` })}
                data-testid={s.testid}
                aria-label={s.href === "#" ? `${s.label} (link coming soon)` : `Tyrell Property Services on ${s.label}`}
                className="flex h-11 w-11 items-center justify-center border border-[#C5A059]/25 text-slate-400 transition-all duration-300 hover:border-[#C5A059] hover:text-[#C5A059]"
              >
                <s.icon size={17} />
              </a>
            ))}
          </div>
          <p className="mt-5 text-xs font-light text-slate-500">
            Follow the latest projects on Instagram &amp; Facebook — LinkedIn coming soon.
          </p>
          <a href="/admin" data-testid="footer-admin-link" className="mt-6 inline-block text-[10px] uppercase tracking-[0.25em] text-slate-600 transition-colors hover:text-[#C5A059]">
            Admin
          </a>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-[#C5A059]/10 pt-8 sm:flex-row">
        <p className="text-xs font-light tracking-wide text-slate-500">
          © 2026 Tyrell Property Services. All rights reserved.
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600">
          Essex, United Kingdom
        </p>
      </div>
    </div>
  </footer>
);
